export default (ngModule) => {
  ngModule
    .directive('mapa', function mapa($window, $q, Mapa) {
      return {
        restrict: 'E',
        link: link
      };

      function link() {
        Mapa.registrarCbCarregarApi(cbCarregarApi);
      }

      function cbCarregarApi() {
        if ($window.google && $window.google.maps) {
          return $q.when($window.google.maps);
        } else if (Mapa.apiPromise && !Mapa.estavaOffline) {
          return $q.when(Mapa.apiPromise.promise);
        } else {
          return carregarApi();
        }
      }

      function carregarApi() {
        Mapa.apiPromise = Mapa.apiPromise || $q.defer();

        carregarScriptApi();

        return Mapa.apiPromise.promise;
      }

      function carregarScriptApi() {
        var script = $window.document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://maps.googleapis.com/maps/api/js?v=3.exp&language=pt-BR&callback=apiCarregada';
        $window.document.body.appendChild(script);

        $window.apiCarregada = function () {
          Mapa.apiPromise.resolve($window.google.maps);
        };
      }
    });
};



/** WEBPACK FOOTER **
 ** ./common/components/mapa/mapa.directive.ts
 **/